// extracted by mini-css-extract-plugin
export default {"categories-container":"Categories_categories-container__BOHpW","categories":"Categories_categories__-zLMR","category-list-container":"Categories_category-list-container__zzwVt"};